import { Component, OnInit } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { Router } from "@angular/router";

@Component({
  selector: "app-cancellation-policy",
  templateUrl: "./cancellation-policy.component.html",
  styleUrls: ["./cancellation-policy.component.css"],
})
export class CancellationPolicyComponent implements OnInit {
  token: any;
  constructor(
    private matdialogref: MatDialogRef<CancellationPolicyComponent>,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.token = sessionStorage.getItem("token");
    if (this.token == null) {
      this.router.navigateByUrl("/");
    }
  }
  close() {
    this.matdialogref.close();
  }
}
